import './dettaglio-news.scss';

/**
 * version    1.0
 * class      <type> (Dettaglio News)
 * classdesc  Component that contains the logic for the article detail page
 */
export class DettaglioNews {}
